export default "__VITE_ASSET__VzkJKz6v__"